export default "__VITE_ASSET__Djf5tEL___"